// Dark mode
const themeModeToggle = document.querySelector('.theme-mode-toggle');
const themeSlider = document.getElementsByClassName('slider')[0];
const themeModeLink = document.getElementsByClassName('theme-mode-link');
const currentTheme = localStorage.getItem('theme');

let checkbox = document.getElementById('mob-theme-mode');
let body_classes = document.body.classList;

if (currentTheme == 'dark') {
    turn_on_dark_mode(body_classes);
} else {
    turn_off_dark_mode();
}

document
    .getElementById('mob-theme-mode')
    .addEventListener('change', function (e) {
        if (document.getElementById('mob-theme-mode').checked == true) {
            turn_on_dark_mode(body_classes);
        } else {
            turn_off_dark_mode();
        }

        if (typeof DISQUS != 'undefined') {
            DISQUS.reset({ reload: true });
        }
    });

for (var i = 0; i < themeModeLink.length; i++) {
    themeModeLink[i].addEventListener('click', function (e) {
        e.preventDefault();

        if (e.target.tagName.toUpperCase() === 'SPAN') {
            return;
        }

        let mode_type = this.getAttribute('data-theme-type');

        if (mode_type == 'goto-dark') {
            turn_on_dark_mode(body_classes);
        } else {
            turn_off_dark_mode();
        }

        if (typeof DISQUS != 'undefined') {
            DISQUS.reset({ reload: true });
        }
    });
}

function turn_on_dark_mode(body_classes) {
    localStorage.setItem('theme', 'dark');

    if (body_classes.contains('theme--dark') == false) {
        document.body.classList.add('theme--dark');
    }
    document.getElementById('mob-theme-mode').checked = true;
}

function turn_off_dark_mode() {
    localStorage.removeItem('theme');
    document.body.classList.remove('theme--dark');
    document.getElementById('mob-theme-mode').checked = false;
}
